import React, {useEffect, useState} from 'react';
import {Box, Button, Grid, Modal} from "@mui/material";
import {PopupHeader} from "../../../../../../com/popupHeader/popupHeader";
import {makeStyles} from "@mui/styles";
import {TextareaWithLabel} from "../../../../../../../com/textareaWithLabel/textareaWithLabel";
import {UpdatePasswordDto} from "../../../../../../../dtos";
import {useDispatch} from "react-redux";
import {updateUserPassword} from "../../../../../../../store/actionCreators/updatePasswordActionCreators";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";
import {ActionType} from "../../../../../../../store/actionTypes";
import {PageSpinner} from "../../../../../../com/pagesTab/pagesSpinner/spinner";
import {resetFlyerState} from "../../../../../../../store/actionCreators/flippingFlyerActionCreators";
import {clearFlyersData} from "../../../../../../../store/actionCreators/flyersActionCreators";
import {history} from "../../../../../../../helpers/history";
import { logout } from '../../../../../../../store/actionCreators';
import StatusPopup, {StatusPopupType} from "../../../../../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../../../../../pages/getSetttingsForPopup";

const useStyles = makeStyles(() => ({
    changePasswordPopupWrapper: {
        width: `30vw`,
        backgroundColor: `#ffffff`,
        display: `flex`,
        flexFlow: `column`,
        "& .MuiInputBase-input": {
            padding: `5px`,
            height: `20px`,
        }
    },
    changePasswordPopupContent: {
        padding: "20px",
        rowGap: "20px",
        display: "flex",
        flexFlow: "column",
    },
    changePasswordFieldsWrapper: {
        display: "flex",
        rowGap: "16px",
        flexFlow: "column",
    },
    saveBtn: {
        "&.MuiButton-root": {
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px",
            /* or 157% */

            textAlign: "center",

            color: "#FFFFFF",
            width: "100%",
            borderRadius: "2px",

            background: "linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)",

            paddingTop: "8px",
            paddingBottom: "8px",
            "&.Mui-disabled": {
                opacity: "0.5",
                color: "#FFFFFF",

            }
        },
    }

}))

interface ChangePasswordDto {
    currentPassword: string,
    newPassword: string,
    confirmPassword: string,
}

interface Props {
    setIsOpenChangePasswordPopup: (value: boolean) => void;
}

export const ChangePasswordPopup: React.FC<Props> = ({
                                                         setIsOpenChangePasswordPopup
                                                     }) => {
    const dispatch = useDispatch();
    const {updatePassword} = useTypedSelector((state) => state);
    const [state, setState] = useState<ChangePasswordDto>({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const defaultState: ChangePasswordDto = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    };

    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [isShowSuccessPopup, setIsShowSuccessPopup] = useState<boolean>(false);

    const classes = useStyles();
    const mainLabelColumnNumber = 12;
    const secondaryLabelColumnNumber = 8;


    useEffect((): void => {
        if (state) {
            const isNoChanges = compareCurrentAndDefaultState(defaultState, state);
            if (isNoChanges) {
                setIsDisabled(isNoChanges);
            } else {
                const isDisabled = state.currentPassword.length < 6
                    || state.confirmPassword !== state.newPassword
                    || !state.newPassword
                    || state.newPassword.length < 6
                    || !state.confirmPassword
                    || state.confirmPassword.length < 6;
                setIsDisabled(isDisabled);
            }
        }
    }, [state]);

    useEffect(() => {
        if(updatePassword.type === ActionType.UPDATE_USER_PASSWORD_SUCCESS){
            setIsShowSuccessPopup(true);
        }
    }, [updatePassword.type])

    const handleClose = (): void => {
        setIsOpenChangePasswordPopup(false);
    }

    const compareCurrentAndDefaultState = (defaultState: ChangePasswordDto, currentState: ChangePasswordDto): boolean => {
        return JSON.stringify(defaultState) === JSON.stringify(currentState);
    }

    const onChangeInput = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        const {value, name} = e.target;
        setState({
            ...state,
            [name]: value.trim()
        });
    }

    const handleSave = (): void => {
        const requestBody: UpdatePasswordDto = {
            currentPassword: state.currentPassword,
            newPassword: state.newPassword
        }

        dispatch(updateUserPassword(requestBody));
    }

    const signout = () => {
        setIsOpenChangePasswordPopup(false);
        setIsShowSuccessPopup(false);
        dispatch(logout());
        dispatch(resetFlyerState());
        dispatch(clearFlyersData());
        history.push('/auth/flyersCatalog/signInForm')
    }

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: ['Your password was updated.', 'Please re-enter to the system using new password.'],
        modalName: 'success',
    };

    let settingsForPopup = getSettingsForPopup(settings);


    return (
        <>
            <Modal
                open={true}
                sx={{
                    display: `flex`,
                    justifyContent: `center`,
                    alignItems: `center`,
                }}
            >
                <Box className={classes.changePasswordPopupWrapper}>
                    {
                        updatePassword.loading &&
                        <Box
                            sx={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                background: "#ffffffB3",
                                zIndex: "1",
                            }}
                        >
                            <PageSpinner/>
                        </Box>
                    }
                    <PopupHeader
                        headerCaption={"Change Password"}
                        onClose={handleClose}
                        bg={"linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)"}
                        jc={"flex-start"}
                    />
                    <Box className={classes.changePasswordPopupContent}>
                        <Box className={classes.changePasswordFieldsWrapper}>
                            <Grid container alignItems={`center`}
                                  columns={36}>
                                <TextareaWithLabel
                                    labelGridSizeNumber={mainLabelColumnNumber}
                                    valueForInput={state.currentPassword}
                                    labelCaption={'Current Password:'}
                                    isBold={true}
                                    maxLength={100}
                                    onChangeInput={onChangeInput}
                                    isRequired={true}
                                    fieldName={'currentPassword'}
                                    labelAlign={"start"}
                                    type={"password"}
                                    isNotValid={state.currentPassword.length < 6 }
                                    requiredFieldIdentificationColor={"#008000"}
                                />
                            </Grid>
                            <Grid container alignItems={`center`}
                                  columns={36}>
                                <TextareaWithLabel
                                    labelGridSizeNumber={mainLabelColumnNumber}
                                    valueForInput={state.newPassword}
                                    labelCaption={'New Password:'}
                                    isBold={true}
                                    maxLength={100}
                                    onChangeInput={onChangeInput}
                                    isRequired={true}
                                    labelAlign={"start"}
                                    fieldName={'newPassword'}
                                    type={"password"}
                                    isNotValid={!state.newPassword || state.newPassword.length < 6}
                                    requiredFieldIdentificationColor={"#008000"}
                                />
                            </Grid>
                            <Grid container alignItems={`center`}
                                  columns={36}>
                                <TextareaWithLabel
                                    labelGridSizeNumber={mainLabelColumnNumber}
                                    valueForInput={state.confirmPassword}
                                    labelCaption={'Confirm New Password:'}
                                    isBold={true}
                                    maxLength={100}
                                    onChangeInput={onChangeInput}
                                    isNotValid={state.confirmPassword !== state.newPassword || !state.confirmPassword || state.confirmPassword.length < 6}
                                    isRequired={true}
                                    fieldName={'confirmPassword'}
                                    labelAlign={"start"}
                                    type={"password"}
                                    requiredFieldIdentificationColor={"#008000"}
                                />
                            </Grid>
                        </Box>
                        <Box>
                            <Grid container columns={36}>
                                <Grid item xs={mainLabelColumnNumber + secondaryLabelColumnNumber}>

                                </Grid>
                                <Grid item xs>
                                    <Button className={classes.saveBtn} onClick={handleSave}
                                            disabled={isDisabled}>Save</Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.CONFIRM}
                title={'SUCCESS'}
                subTitle={''}
                messages={settingsForPopup.messages}
                show={isShowSuccessPopup}
                handleClose={() => signout()}
            />
        </>
    )
}